import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { ReceiptFormTypes } from "models/formTypes";
import { AddPaymentMethodFormContainerProps } from "models/propTypes/receiptPropTypes";
//#endregion
//#region components
import AddPaymentMethodFormContainer from "../../forms/addPaymentMethodFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useUpdatePaymentMethodDialog() {
  return (
    paymentMethod: AddPaymentMethodFormContainerProps,
    onActionSuccess?: (values: ReceiptFormTypes.AddPaymentMethod) => void
  ): DialogProps => ({
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.EditPaymentMethod),
    subTitle: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PaymentMethodSettings),
    titleIcon: IconDefinitionConstants.WTransactions,
    dialogType: DialogEnums.DialogType.Content,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.SaveChanges),
        successMessage: TranslationKeys.Receipt.PaymentMethodSavedSuccessMessage,
      },
    ],
    children: <AddPaymentMethodFormContainer {...paymentMethod}></AddPaymentMethodFormContainer>,
    onSubmit: onActionSuccess,
    maxWidth: "sm",
  });
}

export default useUpdatePaymentMethodDialog;
